export default __webpack_public_path__ + "static/media/desc.44a4f83c.svg";